import "./InfoArticle.scss";

export const InfoArticle = ({ data, style }) => (
  <div className="info" style={style}>
    <p className="info-data">{data}</p>
  </div>
);
